import { React, useState } from "react"
import Gameboard from "./Gameboard.js"
import Scoreboard from "./Scoreboard.js"
import Footer from "./Footer.js"
import "../styles/styles.css"
import Navbar from "./Navbar.js"

function App() {
  const [scoreByCert, setScoreByCert] = useState({
    admin1: 0,
    admin2: 0,
    "app-builder": 0,
    "business-analyst": 0,
    developer1: 0,
  })
  const [activeCert, setActiveCert] = useState("admin1")

  const score = scoreByCert[activeCert] || 0

  const setScore = (valueOrUpdater) => {
    setScoreByCert((prev) => ({
      ...prev,
      [activeCert]:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev[activeCert] || 0)
          : valueOrUpdater,
    }))
  }

  const resetCertScore = () => {
    setScoreByCert((prev) => ({ ...prev, [activeCert]: 0 }))
  }

  return (
    <>
      <div id="navContainer">
        <Navbar activeCert={activeCert} setActiveCert={setActiveCert} />
      </div>
      <div id="app">
        <Gameboard score={score} setScore={setScore} activeCert={activeCert} resetCertScore={resetCertScore} />
      </div>
      <div id="scoreboardContainer">
        <Scoreboard score={score} />
      </div>
      <Footer />
    </>
  )
}

export default App
